import { motion } from "framer-motion";
import { Moon, Users, Flame } from "lucide-react";

const PILLARS = [
  {
    icon: Moon,
    title: "Built on Deen",
    text: "Faith is the foundation. Every thread is a reminder of what comes first — Deen over Dunya, always.",
  },
  {
    icon: Users,
    title: "Raised by Culture",
    text: "Born in the streets, shaped by community. We honour where we come from without compromising who we are.",
  },
  {
    icon: Flame,
    title: "Worn with Purpose",
    text: "This isn't just clothing — it's a statement. Carry your identity boldly, unapologetically, with intention.",
  },
];

export const Pillars = () => {
  return (
    <section
      data-testid="brand-story-section"
      className="relative py-24 sm:py-32"
    >
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8">
        <div className="text-center mb-14 sm:mb-20">
          <p className="font-mono-d text-[11px] uppercase tracking-[0.3em] text-[#ff2a85] mb-4">
            The Identity
          </p>
          <h2 className="font-display font-extrabold uppercase leading-[0.95] text-4xl sm:text-5xl lg:text-6xl tracking-tight">
            This isn't just clothing.
          </h2>
          <p className="mt-4 font-serif-accent text-2xl text-[#5f5e5a]">
            It's an identity.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-5">
          {PILLARS.map((p, i) => {
            const Icon = p.icon;
            return (
              <motion.div
                key={p.title}
                data-testid={`pillar-${i}`}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.7, delay: i * 0.12, ease: [0.16, 1, 0.3, 1] }}
                className="group relative p-8 rounded-2xl border border-[#e3e2dc] bg-[#faf9f6] overflow-hidden hover:-translate-y-2 transition-transform duration-500"
              >
                <div className="absolute -top-16 -right-16 h-40 w-40 rounded-full bg-[#ff2a85]/0 group-hover:bg-[#ff2a85]/10 blur-3xl transition-colors duration-700" />
                <div className="h-14 w-14 rounded-xl border border-[#e3e2dc] flex items-center justify-center mb-7 text-[#ff2a85] group-hover:border-[#ff2a85]/50 transition-colors duration-500">
                  <Icon size={24} strokeWidth={1.5} />
                </div>
                <span className="font-mono-d text-[11px] text-[#5f5e5a]">
                  0{i + 1}
                </span>
                <h3 className="font-display font-extrabold uppercase text-2xl mt-2 mb-4 leading-tight">
                  {p.title}
                </h3>
                <p className="text-[#5f5e5a] text-sm sm:text-base leading-relaxed">
                  {p.text}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
